import { axiosInstance as request } from '@api/rest.service'

const api = view => `/list-views/${view}/user-config`

/**
 * @description GET /list-views/{listView}/user-config
 * @returns {AxiosPromise<any>}
 */
export const GET_LIST_VIEW_TABLE_STATE = listView => request.get(api(listView))

/**
 * @description PATCH /list-views/{listView}/user-config
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_LIST_VIEW_TABLE_STATE = (listView, payload) => request.patch(api(listView), payload)
